const HeadTitle = ({ content, align }) => {
  return (
    <div className="head-title" style={align ? { textAlign: align } : {}}>
      <span>{content}</span>
    </div>
  );
};

export default HeadTitle;
